import { cn } from '../lib/utils';
import type { UiTone } from '../contracts';

interface ProgressProps {
  value: number;
  max?: number;
  label?: string;
  valueLabel?: string;
  tone?: UiTone;
  className?: string;
}

const toneClassName: Record<UiTone, string> = {
  neutral: 'bg-slate-500',
  current: 'bg-primary-600',
  success: 'bg-success-600',
  warning: 'bg-warning-600',
  danger: 'bg-error-600',
  locked: 'bg-slate-300',
};

export function Progress({
  value,
  max = 100,
  label,
  valueLabel,
  tone = 'current',
  className,
}: ProgressProps) {
  const percent = max > 0 ? Math.max(0, Math.min(100, Math.round((value / max) * 100))) : 0;

  return (
    <div className={cn('space-y-2', className)}>
      {label && (
        <div className="flex items-center justify-between text-xs font-medium text-slate-500">
          <span>{label}</span>
          <span>{valueLabel ?? `${percent}%`}</span>
        </div>
      )}
      <div className="h-2 overflow-hidden rounded-full bg-slate-100">
        <div
          className={cn('h-full rounded-full transition-all duration-300', toneClassName[tone])}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
